// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"22fd60e3","453":"f572628e","732":"190ae544","977":"343d6709"}[chunkId] + ".chunk.js";
};